import axios from 'axios';
import config from '../../config';

const BASE_URL = `${config.API_BASE_URL}/api/v1/dashboard`;

/**
 * Obtiene las métricas principales del dashboard
 */
export const getMetricasPrincipales = async (token, periodo = 'semana', fecha_inicio, fecha_fin) => {
  const params = { periodo };
  if (periodo === 'personalizado' && fecha_inicio && fecha_fin) {
    params.fecha_inicio = fecha_inicio;
    params.fecha_fin = fecha_fin;
  }

  const response = await axios.get(`${BASE_URL}/metricas`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });

  return response.data;
};

/**
 * Obtiene servicios agrupados por día
 */
export const getServiciosPorDia = async (token, periodo = 'semana', fecha_inicio, fecha_fin) => {
  const params = { periodo };
  if (periodo === 'personalizado' && fecha_inicio && fecha_fin) {
    params.fecha_inicio = fecha_inicio;
    params.fecha_fin = fecha_fin;
  }

  const response = await axios.get(`${BASE_URL}/servicios-por-dia`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });

  return response.data;
};

/**
 * Obtiene top 5 servicios más solicitados
 */
export const getTopServicios = async (token, periodo = 'semana', fecha_inicio, fecha_fin) => {
  const params = { periodo };
  if (periodo === 'personalizado' && fecha_inicio && fecha_fin) {
    params.fecha_inicio = fecha_inicio;
    params.fecha_fin = fecha_fin;
  }

  const response = await axios.get(`${BASE_URL}/top-servicios`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });

  return response.data;
};

/**
 * Obtiene top 5 trabajadores
 */
export const getTopTrabajadores = async (token, periodo = 'semana', fecha_inicio, fecha_fin) => {
  const params = { periodo };
  if (periodo === 'personalizado' && fecha_inicio && fecha_fin) {
    params.fecha_inicio = fecha_inicio;
    params.fecha_fin = fecha_fin;
  }

  const response = await axios.get(`${BASE_URL}/top-trabajadores`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });

  return response.data;
};

/**
 * Obtiene distribución de servicios por estado
 */
export const getDistribucionEstados = async (token, periodo = 'semana', fecha_inicio, fecha_fin) => {
  const params = { periodo };
  if (periodo === 'personalizado' && fecha_inicio && fecha_fin) {
    params.fecha_inicio = fecha_inicio;
    params.fecha_fin = fecha_fin;
  }

  const response = await axios.get(`${BASE_URL}/distribucion-estados`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });

  return response.data;
};

/**
 * Obtiene evolución de ingresos
 */
export const getEvolucionIngresos = async (token, periodo = 'semana', fecha_inicio, fecha_fin) => {
  const params = { periodo };
  if (periodo === 'personalizado' && fecha_inicio && fecha_fin) {
    params.fecha_inicio = fecha_inicio;
    params.fecha_fin = fecha_fin;
  }

  const response = await axios.get(`${BASE_URL}/evolucion-ingresos`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });

  return response.data;
};

/**
 * Obtiene métricas secundarias
 */
export const getMetricasSecundarias = async (token, periodo = 'semana', fecha_inicio, fecha_fin) => {
  const params = { periodo };
  if (periodo === 'personalizado' && fecha_inicio && fecha_fin) {
    params.fecha_inicio = fecha_inicio;
    params.fecha_fin = fecha_fin;
  }

  const response = await axios.get(`${BASE_URL}/metricas-secundarias`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });

  return response.data;
};

/**
 * Obtiene todos los datos del dashboard en una sola llamada
 */
export const getTodosDatos = async (token, periodo = 'semana', fecha_inicio, fecha_fin) => {
  try {
    const [
      metricasResponse,
      serviciosPorDia,
      topServicios,
      topTrabajadores,
      distribucion,
      evolucion,
      metricasSecundarias
    ] = await Promise.all([
      getMetricasPrincipales(token, periodo, fecha_inicio, fecha_fin),
      getServiciosPorDia(token, periodo, fecha_inicio, fecha_fin),
      getTopServicios(token, periodo, fecha_inicio, fecha_fin),
      getTopTrabajadores(token, periodo, fecha_inicio, fecha_fin),
      getDistribucionEstados(token, periodo, fecha_inicio, fecha_fin),
      getEvolucionIngresos(token, periodo, fecha_inicio, fecha_fin),
      getMetricasSecundarias(token, periodo, fecha_inicio, fecha_fin)
    ]);

    // Extraer moneda de la respuesta de métricas
    const { moneda, ...metricas } = metricasResponse;

    return {
      moneda: moneda || 'PEN',
      metricas,
      serviciosPorDia,
      topServicios,
      topTrabajadores,
      distribucion,
      evolucion,
      metricasSecundarias
    };
  } catch (error) {
    console.error('Error al obtener datos del dashboard:', error);
    throw error;
  }
};
